export default __webpack_public_path__ + "static/media/prenatalLandingPageWebsliderMobile.59b7df0a.png";